import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import { notificationType } from '../../../../types/notifications';
import { useCountries } from '../../../../hooks/useCountries';
import { useMemo, useState } from 'react';
import { updateUserMarket } from '../api-calls';
import { AdminPanelPermissionsDataType, UserObject } from '../permissionTabTypes';

interface EditUserMarketProps {
  initialMarkets: string;
  isOpen: boolean;
  user: UserObject;
  setNotificationState: React.Dispatch<React.SetStateAction<notificationType>>;
  setShowEditUserMarketDialog: React.Dispatch<React.SetStateAction<boolean>>;
  setAdminPanelData: React.Dispatch<React.SetStateAction<AdminPanelPermissionsDataType>>;
}

function EditUserMarketDialog({
  initialMarkets,
  isOpen,
  user,
  setNotificationState,
  setShowEditUserMarketDialog,
  setAdminPanelData,
}: EditUserMarketProps) {
  const [selectedMarkets, setSelectedMarkets] = useState(
    initialMarkets !== 'None'
      ? initialMarkets
          .split(',')
          .map((countryName: string) => countryName.trim())
      : []
  );

  const { countries, getCountryCodes } = useCountries();

  const countriesList: string[] = useMemo(() => countries.map((c) => c.label), [countries]);

  const handleModalClosure = () => {
    setShowEditUserMarketDialog(false);
  };

  const handleUpdateUserMarket = async () => {

    let market = getCountryCodes(selectedMarkets);
    if(Array.isArray(market)) {
        market = market.join(',').trim();
    }
    const result = await updateUserMarket(user.email, user.userId, user.groups[0]?.UserPoolId, market, setNotificationState);
    setAdminPanelData(JSON.parse(result["data"]?.getAdminPanelData?.userGroupMap));
    setShowEditUserMarketDialog(false);
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleModalClosure}
      aria-labelledby='parent-modal-title'
      aria-describedby='parent-modal-description'
    >
      <DialogTitle>Select Markets(Countries)</DialogTitle>
      <DialogContent>
          <Autocomplete
            sx={{width: '400px', minHeight: '100px', marginTop: '10px'}}
            multiple
            options={countriesList}
            getOptionLabel={(option) => option}
            data-testid={'admin-panel-market-autocomplete'}
            defaultValue={selectedMarkets}
            filterSelectedOptions
            onChange={(e, value) => {
              setSelectedMarkets(value);
            }}
            renderInput={(params) => (
              <TextField data-testid={'country-list'} {...params} label='Select Countries' />
            )}
          />
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={handleModalClosure}>
          Cancel
        </Button>
        <Button
          onClick={() => {
            handleUpdateUserMarket();
          }}
          disabled={selectedMarkets === undefined}
          sx={{ marginLeft: '20px' }}
          variant='contained'
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export { EditUserMarketDialog };
